import './ReportPageHeader.scss';

import { Typography } from '@trackman/web-shared-components';
import { DateRangeDto, PitchType, PitchTypeGroup, PlayerHandedness, StrikeZoneDisplay } from 'types/CodegenReportTypes';

import ReportPageHeader from './ReportPageHeader';
import UmpireConditions from './UmpireConditions';
import { useTranslation } from 'react-i18next';
import { displayDate } from 'utilities/dateHelpers';

type Props = {
  leagueName?: string;
  seasonNames?: string[];
  dateRanges?: DateRangeDto[];
  pitchTypes?: PitchType[];
  pitchTypeGroups?: PitchTypeGroup[];
  pitcherHandedness: PlayerHandedness;
  batterHandedness: PlayerHandedness;
  zoneViewMode: StrikeZoneDisplay;
};

const UmpireAdminHeader = ({
  leagueName,
  seasonNames,
  dateRanges,
  pitchTypes,
  pitchTypeGroups,
  pitcherHandedness,
  batterHandedness,
  zoneViewMode,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <ReportPageHeader>
        <Typography key={'leagueName'} variant='h2' component='div' color='#414141'>
          {leagueName ?? t('League name')}
        </Typography>
        <Typography variant='body' component='div' color='#414141'>
          |
        </Typography>
        <Typography key={'timeSpan'} variant='body' component='div' color='#414141'>
          {seasonNames?.length
            ? seasonNames.join(', ')
            : dateRanges && dateRanges.length
              ? dateRanges.map((range) => `${displayDate(range.utcDateFrom)} - ${displayDate(range.utcDateTo)}`).join(', ')
              : t('Time period')}
        </Typography>
      </ReportPageHeader>
      <UmpireConditions
        pitchTypes={pitchTypes}
        pitchTypeGroups={pitchTypeGroups}
        pitcherHandedness={pitcherHandedness}
        batterHandedness={batterHandedness}
        zoneViewMode={zoneViewMode}
      />
    </>
  );
};

export default UmpireAdminHeader;
